import getElementsMap from "../../../utils/get-elements-map";
import getLocalTrigger from "../../../utils/get-local-trigger";

/**
 *
 * @param {IterableElementsProps | null} [targets]
 */
const initInitials = (targets = null) => {
  const elements = getElementsMap(targets);

  /** Get all "initials" triggers */
  const initials = getLocalTrigger("initial", elements);
  const shifts = getLocalTrigger("shift", elements);

  /** Loop trough `animate` elements and fire the animate event */
  for (const main of initials.keys()) {
    main.animate(0, true);
  }

  /** Elements with a "shift" */
  for (const main of shifts.keys()) {
    const transform = main.shift.join(" ");

    main.style.setProperty("transform", transform);
  }

  /** Elements with the initial (static) style */
  for (const main of initials.keys()) {
    for (const [parent, css] of main.cssInitials) {
      css[0].setProperty(parent, css[1], css[2]);
    }
  }
};

export default initInitials;
